angular.module('ui.report.reportManager', [])

    .service('reportManager', function ($q, $state, $log, customResourceResolver) {
        var reportConfig;

        var _this = this;

        _.extend(_this, {
            show: show,
            getReportList: getReportList,
            getReportListByName: getReportListByName,
            getReportConfig: getReportConfig
        });

        return _this;

        function getReportConfig() {
            return reportConfig;
        }

        function getReportList(stepCode) {
            //Default reports list is the list of reports to be shown on the items grid
            return getReportListByName(stepCode, "orders-grid-reports");
        }

        function getReportListByName(stepCode, listName) {
            return customResourceResolver.resolveConfig(listName, null, {step: stepCode})
                .then(function (reportsToShow) {

                    //build array of report configs resolvers
                    var reportsGetters = [];
                    _.forEach(reportsToShow, function (value) {
                        reportsGetters.push(customResourceResolver.resolveReport(value, null, {step: stepCode}));
                    });

                    //once all report configs are resolved, build the reports combo
                    return $q.all(reportsGetters)
                        .then(function (results) {
                            var reportComboItems = [];
                            _.forEach(results, function (value, key) {
                                if (value) {
                                    reportComboItems.push(value);
                                } else {
                                    $log.error("Can not read report configuration [" + reportsToShow[key] + "] from configuration file.");
                                }
                            });
                            return reportComboItems;
                        });
                });
        }

        function show(config) {
            if (!config) {
                return;
            }
            reportConfig = config;
            $state.go('client.report');
        }
    })

;